import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "accordion mb-25 border-0",
  id: "content-perission-accordion"
}
const _hoisted_2 = { class: "accordion-item border-0 rounded-0" }
const _hoisted_3 = {
  class: "accordion-button d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0 collapsed p-15 p-sm-20 p-sm-25 p-lg-30 pe-50",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#content-permission-tab",
  "aria-expanded": "false",
  "aria-controls": "content-permission-tab"
}
const _hoisted_4 = { class: "d-sm-flex align-items-center justify-content-between" }
const _hoisted_5 = { class: "fw-medium text-black-emphasis mb-0" }
const _hoisted_6 = {
  id: "content-permission-tab",
  class: "accordion-collapse collapse border-0",
  "data-bs-parent": "#content-perission-accordion"
}
const _hoisted_7 = { class: "accordion-body border-0 py-15 py-sm-20 py-sm-25 py-lg-30" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_11 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0 pe-10" }
const _hoisted_13 = { class: "d-flex align-items-center justify-content-start" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "form-check form-switch form-group" }
const _hoisted_16 = ["disabled", "checked", "onChange", "id", "onUpdate:modelValue"]
const _hoisted_17 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.categories !== undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t('feature.contents.content_permissions')), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("table", _hoisted_9, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('feature.contents.category')), 1 /* TEXT */),
                      _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('feature.contents.$categories.visible')), 1 /* TEXT */)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createCommentVNode(" PERMISSION ROW "),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: category.id
                      }, [
                        _createElementVNode("th", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, _toDisplayString(category.name), 1 /* TEXT */)
                        ]),
                        _createElementVNode("td", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input shadow-none me-8",
                              type: "checkbox",
                              role: "switch",
                              disabled: category.allow === 'all',
                              checked: category.allow === 'all',
                              onChange: ($event: any) => (_ctx.updateCategoryPermission(category)),
                              id: category.id?.toString(),
                              "onUpdate:modelValue": ($event: any) => ((category.patient_permission) = $event)
                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_16), [
                              [_vModelCheckbox, category.patient_permission]
                            ]),
                            (category.allow === 'all')
                              ? (_openBlock(), _createElementBlock("label", {
                                  key: 0,
                                  class: "form-check-label fw-medium position-relative top-4",
                                  for: category.id?.toString()
                                }, _toDisplayString(_ctx.$t(`feature.contents.$categories.$visibility.${category.allow}`)), 9 /* TEXT, PROPS */, _hoisted_17))
                              : _createCommentVNode("v-if", true)
                          ])
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}